<template>
    <u-dialog v-model="shows" persistent width="1200" max-width="100%" title="주문상세">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-row>
            <v-col cols="12">
                <tit-wrap-line noDivider>
                    <template #titleContents>
                        <div class="d-flex flex-column flex-sm-row align-sm-center">
                            <span class="tit tit--xxs">{{ form?.createdAt?.toDate?.() }}</span>
                            <span class="txt txt--sm pl-sm-8px mt-4px mt-sm-0">주문번호: {{ form?.orderNo }}</span>
                        </div>
                    </template>
                </tit-wrap-line>

                <order-view-purchases v-bind="form" />
            </v-col>
            <v-col cols="12" sm="6" v-if="!isOrderTypeStock">
                <!-- S: 배송지정보 -->
                <page-section class="page-section--xs pb-0">
                    <template #containerImmersive>
                        <order-view-receiver v-model="form" @input="init" />
                    </template>
                </page-section>
                <!-- E: 배송지정보 -->
            </v-col>
            <v-col cols="12" :sm="isOrderTypeStock ? undefined : 6">
                <!-- S: 결제정보 -->
                <page-section class="page-section--xs pb-0">
                    <template #containerImmersive>
                        <order-view-payment v-model="form" />
                    </template>
                </page-section>
                <!-- E: 결제정보 -->
            </v-col>
        </v-row>
    </u-dialog>
</template>

<script>
import api from "@/api";
import { ORDER_TYPES } from "@/assets/variables";

import PageSection from "@/components/client/templates/page-section.vue";
import UDialog from "@/components/client/dumb/u-dialog.vue";
import TitWrapLine from "@/components/client/dumb/tit-wrap-line.vue";
import OrderViewPayment from "./order-view-payment.vue";
import OrderViewReceiver from "./order-view-receiver.vue";
import OrderViewPurchases from "./order-view-purchases.vue";

export default {
    components: {
        PageSection,
        UDialog,
        TitWrapLine,
        OrderViewPayment,
        OrderViewReceiver,
        OrderViewPurchases,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // order
    },
    data: () => ({
        form: undefined,

        // ui
        shows: false,
        loading: false,
    }),
    computed: {
        isOrderTypeStock() {
            return this.form?.type == ORDER_TYPES.STOCK.value;
        },
    },
    watch: {
        shows(shows) {
            if (shows) this.init();
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            this.loading = true;

            try {
                this.form = (await api.v1.me.orders.get(this.value))?.order || {};
                // this.emit();
            } finally {
                this.loading = false;
            }
        },

        emit() {
            this.$emit("input", this.form);
        },

        close() {
            this.shows = false;
        },
    },
};
</script>

<style></style>
